import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

export const SmoothScroll = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id = 0;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      const el = hash ? document.getElementById(hash.slice(1)) : null;
      const lenis = window.__lenis;
      if (el) {
        if (lenis) lenis.scrollTo(el, { offset: -96 });
        else el.scrollIntoView();
      } else if (lenis) lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }, hash ? 120 : 0);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
};
